import React from "react";

export function MapSection() {
  return (
    <div className="h-[380px] relative bg-[#e8f0e8] flex items-center justify-center overflow-hidden">
      {/* Map placeholder background */}
      <div className="w-full h-full bg-gradient-to-br from-[#d4e8da] to-[#b8d4c0] flex flex-col items-center justify-center gap-3">
        <svg
          className="w-10 h-10 text-nestlent-green"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
        <span className="text-[0.85rem] tracking-[0.15em] uppercase text-nestlent-green">
          Ponnani, Malappuram, Kerala
        </span>
      </div>

      {/* Pin card */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 bg-white px-6 py-4 rounded shadow-[0_8px_40px_rgba(0,0,0,0.15)] flex items-center gap-4 whitespace-nowrap">
        <div className="text-nestlent-green">
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
            <circle cx="12" cy="10" r="3" />
          </svg>
        </div>
        <div>
          <div className="text-[0.85rem] font-medium text-nestlent-charcoal">
            Nestlent Builders & Developers
          </div>
          <div className="text-[0.75rem] text-nestlent-grey">
            Therayil Complex, Ponnani, Kerala · enquiry@nestlent.com
          </div>
        </div>
      </div>
    </div>
  );
}
